export default __webpack_public_path__ + "static/media/62.3ddf4d77.svg";